import React from 'react'
import {Box, Stack, Text} from '../../vanilla'
import {DeliveryIcon} from '../icons'
import { StackProps } from '../../vanilla/components/Stack'

export const FreeNextDay = React.forwardRef((props:StackProps<"div">, ref:React.Ref<HTMLDivElement>) => {
  const {...rest} = props
  return (

    <Stack flexDirection="row"  {...rest} ref={ref} >
      <DeliveryIcon color="accent0" width="80px" height="40px" />
      <Box>
        <Text as="h3" color="accent0" variant="unstyled" fontSize="lg" fontWeight="bold">
          Free Next Day Delivery
        </Text>
        <Text variant="text6">Minimum spend applies</Text>
      </Box>
    </Stack>
  )
})
